import { useState, useEffect } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { WifiOff, RefreshCcw, Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getSyncQueue } from '@/lib/syncQueue';

export function NetworkStatusBanner() {
  const { isOnline, pendingCount } = useNetworkStatus();
  const [isSyncing, setIsSyncing] = useState(false);
  const [showSynced, setShowSynced] = useState(false);

  useEffect(() => {
    if (isOnline && pendingCount > 0) {
      setIsSyncing(true);
    } else if (isOnline && pendingCount === 0 && isSyncing) {
      setIsSyncing(false);
      setShowSynced(true);
      const timer = setTimeout(() => setShowSynced(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOnline, pendingCount, isSyncing]);

  // Safety: auto-dismiss syncing state after 15 seconds to prevent stuck banner
  useEffect(() => {
    if (!isSyncing) return;
    const safety = setTimeout(() => {
      setIsSyncing(false);
    }, 15000);
    return () => clearTimeout(safety);
  }, [isSyncing]);

  if (isOnline && !isSyncing && !showSynced) return null;

  return (
    <div
      className={cn(
        "fixed bottom-20 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg transition-all duration-500 animate-in fade-in slide-in-from-bottom-4",
        !isOnline ? "bg-destructive text-destructive-foreground" : 
        isSyncing ? "bg-primary text-primary-foreground" : 
        "bg-green-600 text-white"
      )}
    >
      {!isOnline ? (
        <>
          <WifiOff className="w-4 h-4" />
          <span className="text-sm font-medium">
            Offline - {pendingCount} acties in wachtrij
          </span>
        </>
      ) : isSyncing ? (
        <>
          <RefreshCcw className="w-4 h-4 animate-spin" />
          <span className="text-sm font-medium">Synchroniseren...</span>
        </>
      ) : (
        <>
          <Check className="w-4 h-4" />
          <span className="text-sm font-medium">Alles bijgewerkt</span>
        </>
      )}
    </div>
  );
}
